var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.remoteDatasetLoaded)?_c('ContactElement',_vm._b({attrs:{"id":_vm.anchorName}},'ContactElement',_vm.locationInformation,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }